<template>
  <div class="map" ref="map" tabindex="0">

    <app-player :map="map"></app-player>
    <app-search :map="map"></app-search>
    <app-save-search-polygon :map="map"></app-save-search-polygon>
    <app-ratios-vegetacion :map="map"></app-ratios-vegetacion>
    <app-compare :map="map"></app-compare>

    <div class="zoom-btns mt-2 ml-2" ref="zoomBtns">
      <v-tooltip right>
        <v-btn slot="activator" @click="zoomIn" small depressed color="green" outline class="ma-0 border-radius-0 no-border-bottom border-top-radius">
          <v-icon class="black--text">add</v-icon>
        </v-btn>
        <span>Zoom +</span>
      </v-tooltip>
      <v-tooltip right>
        <v-btn slot="activator" :ripple="false" small depressed color="green" outline class="ma-0 border-radius-0 no-border-bottom no-border-top">
          <span class="headline primary--text">{{zoom}}</span>
        </v-btn>
        <span>{{ $t('nivel-zoom') }}</span>
      </v-tooltip>
      <v-tooltip right>
        <v-btn slot="activator" @click="zoomOut" small depressed color="green" outline class="ma-0 border-radius-0 no-border-top border-bottom-radius">
          <v-icon class="black--text">remove</v-icon>
        </v-btn>
        <span>Zoom -</span>
      </v-tooltip>
    </div>

  </div>
</template>

<script>
import AppPlayer from './core/player/Player'
import AppSearch from './core/search/Search'
import AppSaveSearchPolygon from './core/SaveSearchPolygon'
import AppRatiosVegetacion from './core/vegetacion/Ratios'
import AppCompare from './core/compare/Compare'

import AttributionControl from 'ol/control/attribution'

import View from 'ol/view'
import olMap from 'ol/map'
import proj from 'ol/proj'
import OLExtent from 'ol/extent'
import defaultLayers from './defaultLayers'
import KeyboardPan from 'ol/interaction/keyboardpan'
import { projection25830 } from './projs'

import config from '@/config'

/**
 * Mapa de OpenLayers
 * Aquí añadimos componentes que dependen del mapa
 */
export default {

  components: {
    AppPlayer,
    AppSearch,
    AppSaveSearchPolygon,
    AppRatiosVegetacion,
    AppCompare
  },

  data() {
    return {
      map: null
    }
  },
  
  mounted() {
    this.map = this.createMap()

    this.map.getInteractions().forEach(interaction => {
      if(interaction instanceof KeyboardPan) {
        this.map.removeInteraction(interaction)
      }
    })

    this.map.addControl(new AttributionControl)

    defaultLayers.forEach(this.map.addLayer.bind(this.map))

    this.map.once('postcompose', () => {
      this.map.updateSize()
      setTimeout(this.fitIntoProjectExtent.bind(this), 500)
    })

    window.addEventListener('resize', this.onResize)

    this.$watch(() => this.$store.getters.isMainMenuOpened, this.fitMap.bind(this))
  },

  computed: {
    zoom() {
      return this.map ? (this.map.getView().getZoom() | 0) : 0
    }
  },

  methods: {

    fitIntoProjectExtent(duration = 500) {
      const extent = proj.transformExtent(config.bbox, 'EPSG:4326', projection25830)
      this.map.getView().fit(extent, { duration })
    },

    zoomIn() {
      const view = this.map.getView()
      const zoom = view.getZoom() + 1
      const duration = 250

      view.animate({ zoom, duration })
    },
    zoomOut() {
      const view = this.map.getView()
      const zoom = view.getZoom() - 1
      const duration = 250

      view.animate({ zoom, duration })
    },

    createMap() {
      const mapNode = this.$refs.map
      const extent = proj.transformExtent(config.bbox, 'EPSG:4326', projection25830)

      return new olMap({
        controls: [],
        layers: [],
        target: mapNode,
        view: new View({
          projection: projection25830,
          zoom: 5,
          maxZoom: 18,
          center: OLExtent.getCenter(extent)
        })
      })
    },

    onResize() {
      if(!this.map) {
        return
      }

      this.map.updateSize()
      setTimeout(() => this.map.updateSize(), 1000)
    },


    fitMap() {
      let i = 60

      const _fitMap = () => {
        this.map.updateSize()

        if(i--) {
          requestAnimationFrame(_fitMap)
        }
      }
      
      _fitMap()
    }
  }
}
</script>



<style scoped>
  .map {
    width: 100%;
    height: 100%;
  }

  .zoom-btns {
    position: absolute;
    z-index: 1;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.75)
  }

  .zoom-btns button {
    min-width: 40px;
    max-width: 40px;
  }

  .border-radius-0 {
    border-radius: 0;
  }

  .no-border-bottom {
    border-bottom: none;
  }

  .no-border-top {
    border-top: none;
  }

  .border-bottom-radius {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .border-top-radius {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
</style>


// WEBPACK FOOTER //
// Map.vue?6abdcd46